module.exports ={
    Noconnect:"网络异常",
    /**
     * 系统繁忙
     */
    Busy:"系统繁忙",
    /**
     * 成功
     */
    OK:"操作成功",
    /**
     * 保存成功
     */
    SaveOK:"保存成功",
    /**
     * 更新成功
     */
    UpdateOK:"更新成功",
    /**
     * 删除成功
     */
    DeleteOK:"删除成功",
    /**
     * 调用成功
     */
    IotClientOK:"调用成功",
    /**
     * 失败
     */
    Fail:"操作失败",
    /**
     * 保存失败
     */
    SaveFail:"保存失败",
    /**
     * 更新失败
     */
    UpdateFail:"更新失败",
    /**
     * 删除失败
     */
    DeleteFail:"删除失败",
    /**
     * 调用失败
     */
    IotClientFail:"调用失败",
    /**
     * 系统参数未配置
     */
    SysConfig_Notset:"系统参数未配置",
    /**
     * 未知错误
     */
    Fail_UnknownError:"未知错误",
    /**
     * 非法操作
     */
    IllegalOperation:"非法操作",
    /**
     * 原始密码错误
     */
    OriginalPasswordError:"原始密码错误",
    /**
     * 错误的请求
     */
    BadRequest:"错误的请求",
    /**
     * 错误的请求
     */
    ErrorRequest:"错误的请求",
    /**
     * 错误的参数
     */
    ErrorRequestParameter:"错误的参数",
    /**
     * 未经授权
     */
    Unauthorized:"未经授权",
    /**
     * 授权过期
     */
    AuthorizationExpired:"授权过期",
    /**
     * 禁止访问
     */
    Forbidden:"禁止访问",
    /**
     * 没有找到
     */
    NotFound:"Api接口未找到: {return_code}",
    /**
     * 方法不允许
     */
    MethodNotAllowed:"方法不允许",
    /**
     * 当前资源被锁定
     */
    Locked:"当前资源被锁定"
}



// WEBPACK FOOTER //
// ./src/i18n/locales/en-us/modules/network.js